export default __webpack_public_path__ + "static/media/violetGradient.60b3963c.png";